import Vue from 'vue'
import router from './router'
import store from './store'
import queryString from 'query-string'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getStuInfo } from '@/api/user'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'TestHome', 'retrieve', 'user', 'privacy', 'law', 'contact', 'about', 'explain', 'empty', 'forgotPwd'] // no redirect whitelist
const reg = /^\/(agreement|user)\//
router.beforeEach(async (to, from, next) => {
  var query = queryString.parse(location.search)
  console.log('111111', query, to)
  if (query.ocode && query.sign) {
    const userInfo = await Vue.axios.get(`/user/biz/student/pc/psso/login?ocode=${query.ocode}&sign=${query.sign}&stuId=${query.stuId}&telephone=${query.telephone}&timeStamp=${query.timeStamp}`)
    console.log('loginRes----', userInfo)
    Vue.ls.set('USER_INFO', userInfo)
    Vue.ls.set('code', query.ocode)
    Vue.ls.set(ACCESS_TOKEN, userInfo.token.accessToken)
    const res = await getStuInfo()
    store.commit('SET_USER_INFO', res)
    const pathname = '/study/course?ocode=' + userInfo.ocode
    location.replace(`${location.origin}${pathname}`)
    return
  }
  const code = Vue.ls.get('code') ? Vue.ls.get('code') : ''
  if (query.ocode && !code) {
    Vue.ls.set('code', query.ocode)
  }
  query = {
    // ...queryString.parse(location.search),
    ...to.query
  }
  const breadcrumbList = store.state.system.breadcrumbList
  if (to.name === 'login') {
    console.log('2222', to.hash.match(/#(\S*)#/), Vue.ls.get('code'))
    if (to.hash && to.hash.match(/#(\S*)#/)) {
      if (Vue.ls.get('code') !== to.hash.match(/#(\S*)#/)[1]) {
        Vue.ls.set(ACCESS_TOKEN, '')
        // if (!to.hash && Vue.ls.get('code')) {
        //   location.replace(`${location.origin}` + '/user/login/#' + Vue.ls.get('code') + '#')
        // }
      }
    } else {
      if (!to.hash) {
        if (Vue.ls.get('code')) {
          // console.log('2222', `${location.origin}${location.pathname}`)
          location.replace(`${location.origin}` + '/user/login/#' + Vue.ls.get('code') + '#')
        } else {
          // console.log('33333', `${location.origin}` + `/user/empty`)
          location.replace(`${location.origin}` + `/user/empty`)
          return
        }
      }
    }
  }
  if (to.name === 'gradeDetail') {
    to.meta.title = to.query.planclassesName
  }
  if (to.name === 'course' && !from.name) {
    store.commit('setBreadcrumbList', [
      {
        path: '/study',
        name: 'study',
        meta: { title: '学习中心' }
      },
      {
        path: '/course',
        name: 'course',
        meta: { title: '我的课程' }
      }
    ])
  }
  if (from.name && (breadcrumbList.length === to.matched.filter(item => item.name && item.meta.title).length)) {
    const { matched, ...data } = to
    const list = breadcrumbList
    list.pop()
    list.push(data)
    store.commit('setBreadcrumbList', list)
  }
  if (from.name && (breadcrumbList.length < to.matched.filter(item => item.name && item.meta.title).length)) {
    const { matched, ...data } = to
    const list = breadcrumbList
    list.push(data)
    store.commit('setBreadcrumbList', list)
  }
  if (from.name && (breadcrumbList.length > to.matched.filter(item => item.name && item.meta.title).length)) {
    const list = breadcrumbList
    list.pop()
    store.commit('setBreadcrumbList', list)
  }
  // if (!to.hash && Vue.ls.get('code') && to.name !== 'login') {
  //   const pathname = to.path
  //   console.log('2222', query, pathname)
  //   query.ocode = Vue.ls.get('code')
  //   if (!to.query.ocode && !query.sign) {
  //     query = queryString.stringify(query)
  //     // to.query.ocode = Vue.ls.get('code')
  //     location.replace(`${location.origin}${pathname}` + '?' + query)
  //   }
  // }
  NProgress.start() // start progress bar
  if (Vue.ls.get(ACCESS_TOKEN)) {
    if (to.name === 'login') {
      if (from.name) {
        return next(false)
      } else {
        return next({ path: '/', replace: true })
      }
    }
    next()
  } else {
    if (location.pathname === '/user/login' && !to.hash && Vue.ls.get('code')) {
      window.location.reload(`${location.origin}${location.pathname}` + '#' + Vue.ls.get('code') + '#')
    } else {
      if (to.path.match(reg)) {
        if (whiteList.includes(to.name)) {
          // 在免登录白名单，直接进入
          next()
        }
      } else {
        next({ path: 'user/login', replace: true })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
